import React from 'react'
import Userdashboardhomepage from '../components/userdashboardhomepage/Userdashboardhomepage'
const Userdashboard = () => {
  return (
    <main className='userdashboard-page'>
        <Userdashboardhomepage />
    </main>
  )
}

export default Userdashboard